/* BFL Video Widgets — moteur storefront (remplacement Firework).
 * Récupère une playlist via l'app proxy Shopify (/apps/appointments/videos/<handle>),
 * rend le layout demandé (stories, carousel, circle, grid, floating) et partage un
 * lecteur plein écran vertical (scroll-snap) avec CTA WhatsApp.
 * Aucune dépendance externe. Idempotent.
 */
(function () {
  "use strict";
  if (window.__bflVW) return;
  window.__bflVW = true;

  var PROXY = "/apps/appointments/videos/";

  // Analytics vidéo : simple dispatch d'un événement custom relayé (et batché) par le
  // tracker visitor-behavior s'il est actif. Si le consentement analytics est refusé,
  // personne n'écoute : coût nul. Aucune requête réseau propre, aucun listener global.
  function trackVideo(type, v, extra) {
    try {
      var name = String((v && (v.productTitle || v.productHandle)) || (v && v.videoUrl ? String(v.videoUrl).split("/").pop().split("?")[0] : "video")).slice(0, 60);
      var metadata = { action: type, video: name };
      if (extra) { for (var key in extra) { metadata[key] = extra[key]; } }
      document.dispatchEvent(new CustomEvent("bfl:behavior", {
        detail: { type: type, productHandle: (v && v.productHandle) || "", metadata: metadata }
      }));
    } catch (e) {}
  }
  var PRODUCT_VIDEOS_URL = "/apps/appointments/product-videos";
  var cache = {};

  function el(tag, cls, attrs) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (attrs) {
      for (var k in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, k) && attrs[k] != null) {
          node.setAttribute(k, attrs[k]);
        }
      }
    }
    return node;
  }

  function fetchJson(url, cacheKey) {
    if (cache[cacheKey]) return cache[cacheKey];
    var p = fetch(url, { headers: { accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("http_" + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.ok || !Array.isArray(data.videos)) throw new Error("bad_payload");
        return data;
      });
    cache[cacheKey] = p;
    return p;
  }

  function fetchPlaylist(handle) {
    return fetchJson(PROXY + encodeURIComponent(handle), "pl:" + handle);
  }

  // Source des données d'un conteneur : soit une playlist (data-handle), soit
  // toutes les vidéos produit (data-source="product", pour le floating).
  function fetchForContainer(container) {
    if (container.getAttribute("data-source") === "product") {
      return fetchJson(PRODUCT_VIDEOS_URL, "product-videos");
    }
    var handle = container.getAttribute("data-handle");
    if (!handle) return Promise.reject(new Error("no_source"));
    return fetchPlaylist(handle);
  }

  function ctaHref(v) {
    if (v.ctaUrl) return v.ctaUrl;
    if (v.productHandle) return "/products/" + v.productHandle;
    return null;
  }
  function ctaLabel(v) {
    if (v.ctaLabel) return v.ctaLabel;
    if (v.productHandle) return "Voir le produit";
    if (v.productTitle) return v.productTitle;
    return "Découvrir";
  }
  // Titre lisible : nom du produit si lié, sinon le titre — jamais un nom de
  // fichier brut (IMG_1234.MOV) importé depuis Shopify Files.
  function isFilename(s) {
    return typeof s === "string" &&
      (/\.(mov|mp4|m4v|webm|avi)$/i.test(s) || /^(IMG|VID|MOV|MVI|DSC)[-_ ]?\d+/i.test(s));
  }
  function displayTitle(v) {
    if (v.productTitle) return v.productTitle;
    if (v.title && !isFilename(v.title)) return v.title;
    return "";
  }
  function isWhatsApp(href) {
    return typeof href === "string" && /wa\.me|whatsapp/i.test(href);
  }
  // Lien de localisation (Google Maps) → CTA « itinéraire » stylé (ivoire & or).
  function isMapLink(href) {
    return typeof href === "string" && /google\.[a-z.]+\/maps|maps\.app\.goo\.gl|goo\.gl\/maps|maps\.google/i.test(href);
  }
  // Épingle de localisation (icône SVG, couleur pilotée par le CSS).
  var PIN_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-6.2-5.4-6.2-10.2A6.2 6.2 0 0 1 18.2 10.8C18.2 15.6 12 21 12 21z"/><circle cx="12" cy="10.6" r="2.3"/></svg>';

  // Glyphe WhatsApp (SVG, pas d'emoji).
  var WA_SVG =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5.1-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.2c-.2-.1-1.4-.7-1.7-.8-.2-.1-.4-.1-.6.1-.2.3-.6.8-.8 1-.1.2-.3.2-.5.1-.3-.1-1-.4-2-1.2-.7-.7-1.2-1.5-1.4-1.7-.1-.3 0-.4.1-.5l.4-.5c.1-.1.2-.3.2-.4.1-.2 0-.3 0-.5l-.8-1.9c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.7.3-.2.3-.9.9-.9 2.2 0 1.3 1 2.6 1.1 2.8.1.2 1.9 2.9 4.6 4.1.6.3 1.1.4 1.5.6.6.2 1.2.2 1.7.1.5-.1 1.4-.6 1.6-1.2.2-.6.2-1 .1-1.2 0-.1-.2-.2-.5-.3z"/></svg>';

  // Construit le contenu d'un lien CTA : icône (WhatsApp/localisation) + libellé.
  function fillCta(cta, href, label) {
    var icon = isMapLink(href) ? PIN_SVG : (isWhatsApp(href) ? WA_SVG : null);
    if (icon) {
      var ic = el("span", "bfl-vw-cta-ic");
      ic.innerHTML = icon;
      var tx = el("span");
      tx.textContent = label;
      cta.appendChild(ic);
      cta.appendChild(tx);
    } else {
      cta.textContent = label;
    }
  }
  function ctaClass(href) {
    return "bfl-vw-cta" + (isWhatsApp(href) ? " bfl-vw-cta--wa" : "") + (isMapLink(href) ? " bfl-vw-cta--loc" : "");
  }

  // CTA « Commander » : ouvre WhatsApp avec la référence produit pré-remplie.
  // Affiché en plus du CTA principal quand la vidéo est liée à un produit
  // (sauf si le CTA principal pointe déjà vers WhatsApp).
  var WA_PHONE = "212627376882";
  function makeOrderCta(v, primaryHref) {
    if (!v.productHandle && !v.productTitle) return null;
    if (primaryHref && isWhatsApp(primaryHref)) return null;
    var ref = v.productTitle || v.productHandle;
    var url = v.productHandle ? location.origin + "/products/" + v.productHandle : location.href;
    var text = "Bonjour, je souhaite commander : " + ref + " — " + url;
    var href = "https://wa.me/" + WA_PHONE + "?text=" + encodeURIComponent(text);
    var cta = el("a", "bfl-vw-cta bfl-vw-cta--wa", { href: href, target: "_blank", rel: "noopener" });
    fillCta(cta, href, "Commander");
    return cta;
  }

  // Calendrier (icône SVG, couleur pilotée par le CSS).
  var CAL_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.2" y="5" width="17.6" height="16" rx="2.4"/><path d="M3.2 10h17.6M8 3v4M16 3v4"/></svg>';

  // CTA « Prendre rendez-vous » — showroom Casablanca. Rendu uniquement là où le
  // thème l'autorise : le snippet ne pose data-appointment-url que sur le marché
  // Maroc, avec le libellé déjà traduit et l'URL déjà préfixée par la locale. Le
  // réglage est global à la page, donc lu une fois (l'overlay plein écran est
  // partagé et n'a pas de conteneur d'origine).
  var apptCfg;
  function appointmentCfg() {
    if (apptCfg === undefined) {
      var node = document.querySelector(".bfl-vw[data-appointment-url]");
      var url = node && node.getAttribute("data-appointment-url");
      apptCfg = url
        ? { url: url, label: node.getAttribute("data-appointment-label") || "Prendre rendez-vous" }
        : null;
    }
    return apptCfg;
  }
  function makeAppointmentCta(primaryHref) {
    var cfg = appointmentCfg();
    if (!cfg) return null;
    // Pas de doublon si le CTA principal mène déjà à la page rendez-vous.
    if (primaryHref && primaryHref.indexOf("/pages/appointments") !== -1) return null;
    var cta = el("a", "bfl-vw-cta bfl-vw-cta--appt", { href: cfg.url });
    var ic = el("span", "bfl-vw-cta-ic");
    ic.innerHTML = CAL_SVG;
    var tx = el("span");
    tx.textContent = cfg.label;
    cta.appendChild(ic);
    cta.appendChild(tx);
    return cta;
  }

  function makeTileVideo(v) {
    // Rendition SD (~480p) pour les petits lecteurs inline — la HD reste pour le plein écran.
    var vid = el("video", null, {
      src: (v.sdUrl || v.videoUrl) + "#t=0.1",
      muted: "",
      loop: "",
      playsinline: "",
      preload: "none"
    });
    vid.muted = true;
    if (v.posterUrl) vid.setAttribute("poster", v.posterUrl);
    applyClip(vid, v);
    vid.__bflReset = v.clipStart != null ? Number(v.clipStart) : 0;
    return vid;
  }

  // Une seule vignette joue à la fois : toucher/survoler un cercle lance sa vidéo
  // et ARRÊTE la précédente (retour au poster). Portée globale au moteur.
  var activeTile = null, activeVid = null;
  function stopActive() {
    if (activeVid) {
      try { activeVid.pause(); } catch (e) {}
      try { activeVid.currentTime = activeVid.__bflReset || 0; } catch (e) {}
    }
    if (activeTile) activeTile.classList.remove("bfl-vw-tile--playing");
    activeTile = null; activeVid = null;
  }
  function playOnly(tile, vid) {
    if (activeTile === tile) {
      var pr0 = vid.play(); if (pr0 && pr0.catch) pr0.catch(function () {});
      return;
    }
    stopActive();
    var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
    tile.classList.add("bfl-vw-tile--playing");
    activeTile = tile; activeVid = vid;
  }

  var BAG_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M6 8h12l-1 11a2 2 0 0 1-2 1.8H9A2 2 0 0 1 7 19L6 8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';

  function makeTile(v, onOpen) {
    var tile = el("div", "bfl-vw-tile");
    var vid = makeTileVideo(v);
    tile.appendChild(vid);
    var play = el("div", "bfl-vw-play");
    play.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.14v13.72L19 12 8 5.14z"/></svg>';
    tile.appendChild(play);
    // Lecture au survol / au toucher : une seule vignette à la fois. La vidéo
    // continue de tourner après la sortie de souris, mais toucher un AUTRE cercle
    // arrête celle-ci. Le clic ouvre le lecteur plein écran.
    function hoverPlay() { playOnly(tile, vid); }
    tile.addEventListener("mouseenter", hoverPlay);
    tile.addEventListener("touchstart", hoverPlay, { passive: true });
    // Badge produit (comme Firework) sur les vidéos taggées.
    if (v.productHandle) {
      var bag = el("div", "bfl-vw-bag", { "aria-hidden": "true" });
      bag.innerHTML = BAG_SVG;
      tile.appendChild(bag);
    }
    var tTitle = displayTitle(v);
    if (tTitle) {
      var t = el("div", "bfl-vw-tile-title");
      t.textContent = tTitle;
      tile.appendChild(t);
    }
    tile.addEventListener("click", onOpen);
    return tile;
  }

  /* ---------------- Overlay plein écran (partagé) ---------------- */
  var overlay = null;

  // Icônes son (haut-parleur) — remplacent les emojis 🔇/🔊. Gris translucide via CSS.
  var SND_ON =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19" fill="currentColor"/><path d="M15.5 8.6a5 5 0 0 1 0 6.8" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M18.4 6a9 9 0 0 1 0 12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  var SND_OFF =
    '<svg viewBox="0 0 24 24" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19" fill="currentColor"/><path d="M16.5 9.5l5 5M21.5 9.5l-5 5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';

  function buildOverlay() {
    if (overlay) return overlay;
    overlay = el("div", "bfl-vw-overlay");
    var stage = el("div", "bfl-vw-stage");
    var top = el("div", "bfl-vw-topbar");
    var muteBtn = el("button", "bfl-vw-btn bfl-vw-sound", { type: "button", "aria-label": "Couper le son" });
    muteBtn.innerHTML = SND_ON;
    var closeBtn = el("button", "bfl-vw-btn", { type: "button", "aria-label": "Fermer" });
    closeBtn.textContent = "✕";
    top.appendChild(muteBtn);
    top.appendChild(closeBtn);
    var prev = el("button", "bfl-vw-nav bfl-vw-nav-prev", { type: "button", "aria-label": "Précédent" });
    prev.textContent = "↑";
    var next = el("button", "bfl-vw-nav bfl-vw-nav-next", { type: "button", "aria-label": "Suivant" });
    next.textContent = "↓";
    overlay.appendChild(stage);
    overlay.appendChild(top);
    overlay.appendChild(prev);
    overlay.appendChild(next);
    document.body.appendChild(overlay);

    overlay._stage = stage;
    overlay._muted = false; // son activé par défaut (le lecteur s'ouvre au clic)
    overlay._slides = [];

    function setMuted(m) {
      overlay._muted = m;
      overlay._slides.forEach(function (s) { s.video.muted = m; });
      muteBtn.innerHTML = m ? SND_OFF : SND_ON;
      muteBtn.setAttribute("aria-label", m ? "Activer le son" : "Couper le son");
    }
    muteBtn.addEventListener("click", function () { setMuted(!overlay._muted); });
    overlay._setMuted = setMuted;

    function close() {
      overlay.classList.remove("is-open");
      overlay._slides.forEach(function (s) { try { s.video.pause(); } catch (e) {} });
      document.documentElement.style.overflow = "";
      setTimeout(function () {
        stage.innerHTML = ""; overlay._slides = [];
        stage.style.transform = ""; stage.style.transition = "";
      }, 180);
    }
    overlay._close = close;
    closeBtn.addEventListener("click", close);
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });

    function scrollToIndex(i) {
      var s = overlay._slides[i];
      if (s) s.slide.scrollIntoView({ behavior: "smooth" });
    }
    prev.addEventListener("click", function () { scrollToIndex(overlay._active - 1); });
    next.addEventListener("click", function () { scrollToIndex(overlay._active + 1); });

    document.addEventListener("keydown", function (e) {
      if (!overlay.classList.contains("is-open")) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowDown") scrollToIndex(overlay._active + 1);
      else if (e.key === "ArrowUp") scrollToIndex(overlay._active - 1);
    });

    // Mobile : glisser horizontalement (gauche OU droite) ferme le lecteur.
    // Le geste vertical reste réservé à la navigation entre clips (scroll-snap).
    var swX = 0, swY = 0, swActive = false, swHoriz = false;
    stage.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) { swActive = false; return; }
      swX = e.touches[0].clientX; swY = e.touches[0].clientY;
      swActive = true; swHoriz = false;
      stage.style.transition = "";
    }, { passive: true });
    stage.addEventListener("touchmove", function (e) {
      if (!swActive || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - swX, dy = e.touches[0].clientY - swY;
      if (!swHoriz && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.3) swHoriz = true;
      if (swHoriz) {
        e.preventDefault(); // verrouille le scroll vertical pendant le glissement horizontal
        stage.style.transform = "translateX(" + dx + "px)";
      }
    }, { passive: false });
    stage.addEventListener("touchend", function (e) {
      if (!swActive) return;
      swActive = false;
      if (!swHoriz) return;
      var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : swX;
      var dx = endX - swX;
      var threshold = Math.min(120, window.innerWidth * 0.28);
      stage.style.transition = "transform .2s ease";
      if (Math.abs(dx) > threshold) {
        stage.style.transform = "translateX(" + (dx > 0 ? 1 : -1) * window.innerWidth + "px)";
        close();
      } else {
        stage.style.transform = ""; // geste trop court → retour en place
      }
    }, { passive: true });

    return overlay;
  }

  function openOverlay(videos, startIndex) {
    var ov = buildOverlay();
    var stage = ov._stage;
    stage.innerHTML = "";
    ov._slides = [];
    ov._active = startIndex || 0;

    videos.forEach(function (v, i) {
      var slide = el("div", "bfl-vw-slide");
      var vid = el("video", null, { src: v.videoUrl, playsinline: "", preload: i === startIndex ? "auto" : "none", loop: "" });
      vid.muted = ov._muted;
      if (v.posterUrl) vid.setAttribute("poster", v.posterUrl);
      vid.addEventListener("play", function () {
        if (vid._bflPlayed) return;
        vid._bflPlayed = true;
        trackVideo("video_play", v);
      });
      slide.appendChild(vid);
      slide.appendChild(el("div", "bfl-vw-slide-grad"));

      // Barres de progression (une par clip)
      var prog = el("div", "bfl-vw-progress");
      videos.forEach(function (_, j) {
        var seg = el("span");
        seg.appendChild(el("i"));
        if (j < i) seg.className = "is-done";
        prog.appendChild(seg);
      });
      slide.appendChild(prog);

      // Caption + CTA
      var cap = el("div", "bfl-vw-caption");
      var capTitle = displayTitle(v);
      if (capTitle) {
        var title = el("div", "bfl-vw-caption-title");
        title.textContent = capTitle;
        cap.appendChild(title);
      }
      var href = ctaHref(v);
      var ctaRow = el("div", "bfl-vw-cta-row");
      if (href) {
        var cta = el("a", ctaClass(href), {
          href: href,
          target: (isWhatsApp(href) || isMapLink(href)) ? "_blank" : "_self",
          rel: "noopener"
        });
        fillCta(cta, href, ctaLabel(v));
        ctaRow.appendChild(cta);
      }
      var orderCta = makeOrderCta(v, href);
      if (orderCta) ctaRow.appendChild(orderCta);
      var apptCta = makeAppointmentCta(href);
      if (apptCta) ctaRow.appendChild(apptCta);
      if (ctaRow.childNodes.length) {
        // Deux boutons : ils encadrent la fleche « suivant » au lieu de la
        // surplomber. Un seul bouton garde la disposition d'origine, sinon il
        // se retrouverait centre sous la fleche.
        if (ctaRow.childNodes.length === 2) cap.className += " bfl-vw-caption--split";
        // Trois boutons (marche Maroc) : la fleche ne peut plus etre encadree,
        // la legende reste au-dessus d'elle et les pastilles se compactent.
        if (ctaRow.childNodes.length > 2) ctaRow.className += " bfl-vw-cta-row--trio";
        cap.appendChild(ctaRow);
      }
      slide.appendChild(cap);

      // Tap sur la vidéo = play/pause
      vid.addEventListener("click", function () {
        if (vid.paused) vid.play(); else vid.pause();
      });
      vid.addEventListener("timeupdate", function () {
        var seg = prog.children[i];
        if (seg && vid.duration) seg.firstChild.style.width = (vid.currentTime / vid.duration * 100) + "%";
        if (vid.duration) {
          var ratio = vid.currentTime / vid.duration;
          if (!vid._bfl50 && ratio >= 0.5) { vid._bfl50 = true; trackVideo("video_progress", v, { milestone: "50" }); }
          if (!vid._bfl90 && ratio >= 0.9) { vid._bfl90 = true; trackVideo("video_complete", v); }
        }
      });

      stage.appendChild(slide);
      ov._slides.push({ slide: slide, video: vid, prog: prog, index: i });
    });

    // IntersectionObserver : joue le clip visible, met les autres en pause
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var idx = ov._slides.map(function (s) { return s.slide; }).indexOf(entry.target);
        if (idx < 0) return;
        var vid = ov._slides[idx].video;
        if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
          ov._active = idx;
          vid.muted = ov._muted;
          var pr = vid.play();
          if (pr && pr.catch) pr.catch(function () {});
          // marque la progression des barres
          ov._slides.forEach(function (s) {
            for (var k = 0; k < s.prog.children.length; k++) {
              s.prog.children[k].className = k < idx ? "is-done" : "";
            }
          });
        } else {
          vid.pause();
        }
      });
    }, { threshold: [0.6] });
    ov._slides.forEach(function (s) { io.observe(s.slide); });
    ov._io = io;

    document.documentElement.style.overflow = "hidden";
    ov.classList.add("is-open");
    ov._setMuted(ov._muted);
    requestAnimationFrame(function () {
      var target = ov._slides[startIndex || 0];
      if (!target) return;
      target.slide.scrollIntoView();
      var pr = target.video.play();
      if (pr && pr.catch) pr.catch(function () {
        // Son bloqué par le navigateur → repli muet pour que la vidéo démarre quand
        // même ; l'utilisateur peut réactiver le son via le bouton haut-parleur.
        ov._setMuted(true);
        var pr2 = target.video.play();
        if (pr2 && pr2.catch) pr2.catch(function () {});
      });
    });
  }

  /* ---------------- Helpers de layout ---------------- */
  function currentProductHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : "";
  }

  // Tous les handles possibles du produit courant. Les marchés traduisent le slug
  // produit (FR/ES/NL…) : l'URL et {{ product.handle }} donnent le slug traduit, mais
  // les <link rel="alternate" hreflang> listent TOUS les slugs — dont le handle canonique
  // (celui stocké avec la vidéo). On matche donc sur cet ensemble, valable sur toute locale.
  function productHandleSet(container) {
    var set = {};
    function add(h) { if (h) { try { set[decodeURIComponent(h)] = 1; } catch (e) { set[h] = 1; } } }
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) add(m[1]);
    if (container) add(container.getAttribute("data-product-handle"));
    var links = document.querySelectorAll('link[rel="alternate"][href], link[rel="canonical"][href]');
    for (var i = 0; i < links.length; i++) {
      var mm = (links[i].getAttribute("href") || "").match(/\/products\/([^\/?#]+)/);
      if (mm) add(mm[1]);
    }
    return set;
  }

  function isProductPage() {
    return /\/products\/[^/?#]/.test(location.pathname);
  }

  // Carrousel dynamique : filtre sur le produit de la page (fallback = toutes).
  function filterByProduct(videos) {
    if (!isProductPage()) return videos;
    var set = productHandleSet();
    var matched = videos.filter(function (v) { return v.productHandle && set[v.productHandle]; });
    return matched.length ? matched : videos;
  }

  // Boucle un lecteur inline sur le segment du poster animé (si défini).
  function applyClip(vid, v) {
    if (v.clipStart == null || v.clipEnd == null) return;
    var cs = Number(v.clipStart), ce = Number(v.clipEnd);
    if (!(ce > cs)) return;
    vid.addEventListener("loadedmetadata", function () { try { vid.currentTime = cs; } catch (e) {} });
    vid.addEventListener("timeupdate", function () {
      if (vid.currentTime > ce || vid.currentTime < cs - 0.05) { try { vid.currentTime = cs; } catch (e) {} }
    });
  }

  function makeInlineVideo(v) {
    var vid = el("video", null, { src: v.videoUrl, muted: "", loop: "", playsinline: "", preload: "metadata" });
    vid.muted = true;
    if (v.posterUrl) vid.setAttribute("poster", v.posterUrl);
    applyClip(vid, v);
    return vid;
  }

  function makeCta(v) {
    var href = ctaHref(v);
    if (!href) return null;
    var cta = el("a", ctaClass(href), { href: href, target: (isWhatsApp(href) || isMapLink(href)) ? "_blank" : "_self", rel: "noopener" });
    fillCta(cta, href, ctaLabel(v));
    return cta;
  }

  /* ---------------- Layouts ---------------- */
  function renderRow(container, data, extraClass) {
    var row = el("div", "bfl-vw-row" + (extraClass ? " " + extraClass : ""));
    data.videos.forEach(function (v, i) {
      row.appendChild(makeTile(v, function () { openOverlay(data.videos, i); }));
    });
    container.appendChild(row);
  }

  // Lecteur unique inline (player / hero / lecteur horizontal) avec titre + CTA.
  function renderSingle(container, data, variant) {
    var v = data.videos[0];
    if (!v) return;
    var wrap = el("div", "bfl-vw-single bfl-vw-single--" + variant);
    var vid = makeInlineVideo(v);
    vid.setAttribute("autoplay", "");
    vid.addEventListener("click", function () { openOverlay(data.videos, 0); });
    wrap.appendChild(vid);
    var cap = el("div", "bfl-vw-single-cap");
    var sTitle = displayTitle(v);
    if (sTitle) { var t = el("div", "bfl-vw-single-title"); t.textContent = sTitle; cap.appendChild(t); }
    var cta = makeCta(v);
    var orderCta = makeOrderCta(v, ctaHref(v));
    var apptCta = makeAppointmentCta(ctaHref(v));
    if (cta || orderCta || apptCta) {
      var ctaRow = el("div", "bfl-vw-cta-row");
      if (cta) ctaRow.appendChild(cta);
      if (orderCta) ctaRow.appendChild(orderCta);
      if (apptCta) ctaRow.appendChild(apptCta);
      if (ctaRow.childNodes.length > 2) ctaRow.className += " bfl-vw-cta-row--trio";
      cap.appendChild(ctaRow);
    }
    if (cap.childNodes.length) wrap.appendChild(cap);
    container.appendChild(wrap);
    var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
  }

  // Player Deck : une vidéo + cartes produits cliquables.
  function renderPlayerDeck(container, data) {
    var v = data.videos[0];
    if (!v) return;
    var wrap = el("div", "bfl-vw-deck");
    var vid = makeInlineVideo(v);
    vid.setAttribute("autoplay", "");
    vid.addEventListener("click", function () { openOverlay(data.videos, 0); });
    wrap.appendChild(vid);
    var cards = el("div", "bfl-vw-deck-cards");
    data.videos.slice(0, 6).forEach(function (vv, i) {
      var href = ctaHref(vv);
      var wa = isWhatsApp(href);
      var card = el(href ? "a" : "div", "bfl-vw-deck-card", href ? { href: href, target: wa ? "_blank" : "_self", rel: "noopener" } : null);
      var thumb = el("span", "bfl-vw-deck-thumb");
      if (vv.posterUrl) thumb.appendChild(el("img", null, { src: vv.posterUrl, alt: "", loading: "lazy" }));
      card.appendChild(thumb);
      var name = el("span", "bfl-vw-deck-name");
      name.textContent = displayTitle(vv) || "Découvrir";
      card.appendChild(name);
      if (!href) card.addEventListener("click", function () { openOverlay(data.videos, i); });
      cards.appendChild(card);
    });
    wrap.appendChild(cards);
    container.appendChild(wrap);
    var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {});
  }

  // Cercles façon Firework : vignettes rondes propres, sans titre ni label.
  function renderCircle(container, data) {
    var row = el("div", "bfl-vw-row");
    data.videos.forEach(function (v, i) {
      row.appendChild(makeTile(v, function () { openOverlay(data.videos, i); }));
    });
    container.appendChild(row);
    autoplayFirst(row);
  }

  // Lance automatiquement le PREMIER cercle dès qu'il entre dans le viewport.
  // Sur mobile (iOS/Android), l'autoplay muet exige muted+playsinline ET une vidéo
  // déjà chargée : preload="none" ne suffit pas (contrairement au desktop où play()
  // déclenche le chargement). On force donc le chargement, puis on lit quand c'est prêt.
  function autoplayFirst(row) {
    var firstTile = row.querySelector(".bfl-vw-tile");
    if (!firstTile) return;
    var fv = firstTile.querySelector("video");
    if (!fv) return;
    fv.muted = true; fv.setAttribute("muted", "");
    fv.playsInline = true; fv.setAttribute("playsinline", "");
    function start() {
      if (activeTile) return; // l'utilisateur a déjà lancé un autre cercle
      playOnly(firstTile, fv);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        if (activeTile) return;
        if (fv.readyState >= 2) { start(); return; }
        fv.preload = "auto";
        fv.addEventListener("loadeddata", start, { once: true });
        try { fv.load(); } catch (_) {}
      });
    }, { threshold: 0.3 });
    io.observe(firstTile);
  }

  function renderGrid(container, data) {
    var grid = el("div", "bfl-vw-grid");
    data.videos.forEach(function (v, i) {
      grid.appendChild(makeTile(v, function () { openOverlay(data.videos, i); }));
    });
    container.appendChild(grid);
  }

  function renderFloating(container, data) {
    // Produit-aware : sur une page produit, ne montrer que la vidéo de CE produit (sinon rien).
    // Matching multi-handle (URL + alternates hreflang) pour couvrir les slugs traduits par marché.
    var vids = data.videos;
    if (isProductPage()) {
      var set = productHandleSet(container);
      var matched = data.videos.filter(function (v) { return v.productHandle && set[v.productHandle]; });
      if (!matched.length) return;
      vids = matched;
    }
    if (!vids.length) return;
    var first = vids[0];
    var side = container && container.getAttribute("data-position") === "left" ? " bfl-vw-floating--left" : "";
    var box = el("div", "bfl-vw-floating" + side);
    var vid = makeTileVideo(first);
    vid.setAttribute("loop", "");
    vid.setAttribute("autoplay", "");
    applyClip(vid, first);
    box.appendChild(vid);
    var close = el("button", "bfl-vw-floating-close", { type: "button", "aria-label": "Fermer" });
    close.textContent = "✕";
    close.addEventListener("click", function (e) { e.stopPropagation(); box.remove(); });
    box.appendChild(close);

    // Pause/lecture + anneau de progression (parité fonctionnelle Firework)
    var RING_C = 97.39; // 2π × r(15.5)
    var ctrl = el("button", "bfl-vw-floating-ctrl", { type: "button", "aria-label": "Pause" });
    ctrl.innerHTML =
      '<svg class="bfl-vw-ctrl-ring" viewBox="0 0 36 36" aria-hidden="true">' +
        '<circle cx="18" cy="18" r="15.5" fill="none" stroke="rgba(255,255,255,.32)" stroke-width="2.4"/>' +
        '<circle class="bfl-vw-ctrl-prog" cx="18" cy="18" r="15.5" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-dasharray="' + RING_C + '" stroke-dashoffset="' + RING_C + '" transform="rotate(-90 18 18)"/>' +
      '</svg>' +
      '<span class="bfl-vw-ctrl-icon"></span>';
    var ctrlProg = ctrl.querySelector(".bfl-vw-ctrl-prog");
    var ctrlIcon = ctrl.querySelector(".bfl-vw-ctrl-icon");
    var PAUSE_ICO = '<svg viewBox="0 0 24 24" fill="currentColor"><rect x="6.5" y="5" width="4" height="14" rx="1"/><rect x="13.5" y="5" width="4" height="14" rx="1"/></svg>';
    var PLAY_ICO = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13l11-6.5z"/></svg>';
    function syncCtrlIcon() {
      ctrlIcon.innerHTML = vid.paused ? PLAY_ICO : PAUSE_ICO;
      ctrl.setAttribute("aria-label", vid.paused ? "Lecture" : "Pause");
    }
    vid.addEventListener("play", syncCtrlIcon);
    vid.addEventListener("pause", syncCtrlIcon);
    syncCtrlIcon();
    vid.addEventListener("timeupdate", function () {
      var cs = 0, ce = vid.duration || 0;
      if (first.clipStart != null && first.clipEnd != null && Number(first.clipEnd) > Number(first.clipStart)) {
        cs = Number(first.clipStart); ce = Number(first.clipEnd);
      }
      if (!(ce > cs)) return;
      var p = Math.min(Math.max((vid.currentTime - cs) / (ce - cs), 0), 1);
      ctrlProg.style.strokeDashoffset = String(RING_C * (1 - p));
    });
    ctrl.addEventListener("click", function (e) {
      e.stopPropagation();
      if (vid.paused) { var pp = vid.play(); if (pp && pp.catch) pp.catch(function () {}); }
      else { vid.pause(); }
    });
    box.appendChild(ctrl);

    box.addEventListener("click", function () { openOverlay(vids, 0); });
    document.body.appendChild(box);

    // Position dynamique : collé au-dessus de la barre CTA sticky (« Book a showroom »)
    // quand elle est visible, sinon tout en bas (valeur CSS de base, façon Firework).
    var atcBar = document.querySelector(".sticky-atc");
    if (atcBar) {
      var syncBottom = function () {
        if (!box.isConnected) return;
        var r = atcBar.getBoundingClientRect();
        var visible = r.height > 0 && r.top < window.innerHeight - 4;
        box.style.bottom = visible ? Math.round(window.innerHeight - r.top + 6) + "px" : "";
      };
      window.addEventListener("scroll", syncBottom, { passive: true });
      window.addEventListener("resize", syncBottom, { passive: true });
      atcBar.addEventListener("transitionend", syncBottom);
      if ("IntersectionObserver" in window) new IntersectionObserver(syncBottom).observe(atcBar);
      syncBottom();
    }

    var pr = vid.play();
    if (pr && pr.catch) pr.catch(function () {});
  }

  function renderWidget(container, data) {
    var widget = container.getAttribute("data-widget") || data.playlist.widget || "stories";
    var heading = container.getAttribute("data-heading");
    container.innerHTML = "";
    container.classList.add("bfl-vw--" + widget);
    if (heading) {
      var h = el("div", "bfl-vw-heading");
      h.textContent = heading;
      container.appendChild(h);
    }
    if (!data.videos.length) { container.setAttribute("hidden", ""); return; }

    if (widget === "grid") {
      renderGrid(container, data);
    } else if (widget === "dynamic") {
      renderGrid(container, { playlist: data.playlist, videos: filterByProduct(data.videos) });
    } else if (widget === "circle") {
      renderCircle(container, data);
    } else if (widget === "floating") {
      renderFloating(container, data);
    } else if (widget === "player") {
      renderSingle(container, data, "v");
    } else if (widget === "hplayer") {
      renderSingle(container, data, "h");
    } else if (widget === "hero") {
      renderSingle(container, data, "hero");
    } else if (widget === "playerdeck") {
      renderPlayerDeck(container, data);
    } else if (widget === "hcarousel") {
      renderRow(container, data, "bfl-vw-row--h");
    } else {
      renderRow(container, data); // stories, storyblock, carousel
    }
  }

  function hydrate(container) {
    if (container.__bflDone) return;
    container.__bflDone = true;
    fetchForContainer(container)
      .then(function (data) { renderWidget(container, data); })
      .catch(function (err) {
        container.setAttribute("hidden", "");
        if (window.console) console.warn("[bfl-vw] source failed:", err && err.message);
      });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(".bfl-vw[data-handle], .bfl-vw[data-source]");
    for (var i = 0; i < nodes.length; i++) hydrate(nodes[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(); });
  } else {
    init();
  }
  // Réhydrate quand l'éditeur de thème recharge une section.
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
